import React from 'react';
import PropTypes from 'prop-types';

import CreateWizardLayout from '../../../../../components/CreateWizardLayout';
import FreemiumSocialDetails from '../../../FreemiumEvents/FreemiumEventSocialDetails';

const propTypes = {
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  touched: PropTypes.object,
};

const FreemiumEventCreateSocialStep = ({
  values,
  errors,
  handleChange,
  handleBlur,
  touched,
}) => {
  return (
    <CreateWizardLayout.Wrapper>
      <CreateWizardLayout.Content>
        <FreemiumSocialDetails
          values={values}
          errors={errors}
          handleChange={handleChange}
          handleBlur={handleBlur}
          touched={touched}
        />
      </CreateWizardLayout.Content>
    </CreateWizardLayout.Wrapper>
  );
};

FreemiumEventCreateSocialStep.propTypes = propTypes;

export default FreemiumEventCreateSocialStep;
